import { Injectable } from '@angular/core';
declare let ga: Function; // Declare ga as a function

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() {
    // console.log("hdjdg")
  }

  // create our event emitter to send our data to google analytics
  public eventEmitter(eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null) {
    ga('send', 'event', {
      eventCategory: eventCategory,
      eventLabel: eventLabel,
      eventAction: eventAction,
      eventValue: eventValue
    });

    // ga('create', 'UA-5361894-1', 'auto');

    // // Only require the plugins you've imported above.
    // ga('require', 'eventTracker');
    // ga('require', 'outboundLinkTracker');
    // ga('require', 'urlChangeTracker');

    // ga('send', 'pageview');

    // ga('create', 'UA-5361894-1', 'auto');

    // ga(function (tracker) {
    //   // Logs the tracker created above to the console.
    //   console.log(tracker);
    // });
  }
}
